// extracted by mini-css-extract-plugin
module.exports = {"line_login":"Login_line_login_1jg4X","text":"Login_text_200C5","mask":"Login_mask_2FJV9","vibration":"Login_vibration_xp7Vu"};